import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconsService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  init() {
    const icons = [
    'active-icon',
    'advice',
    'check-icon--white',
    'check-icon',
    'close-icon',
    'cpit-logo',
    'dead-icon',
    'info-icon'
    ];

    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        `cp-${icon}`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/${icon}.svg`)
      );
    });
  }
}
